import PropTypes from 'prop-types';
import { searchResultsProductsPropTypes } from './components/SearchResultsProducts/SearchResultsProductsPropTypes';
import { searchResultsContentPropTypes } from './components/SearchResultsContent/SearchResultsContentPropTypes';
export const searchResultsPropTypes = {
  searchResults: PropTypes.shape({
    status: PropTypes.shape({
      isFetching: PropTypes.bool,
      isLoaded: PropTypes.bool
    }),
    notFoundDescription: PropTypes.string,
    products: PropTypes.shape(searchResultsProductsPropTypes),
    content: searchResultsContentPropTypes.items
  }),
  setIsSearching: PropTypes.func,
  isSearching: PropTypes.bool,
  searchTerm: PropTypes.string,
  sendSearchData: PropTypes.func
};